import { useWebsite } from 'hooks/website/useWebsite';

import s from './BillboardPreviewImage.module.css';

export const BillboardPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Billboard Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
